const actions = {
    update({ commit }) {
        commit('update')
    }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/action.js